/**
 * DrawerPlugin,拖出该按钮，动态创建一个通栏
 */
import { primaryStagePageLayoutGenerator as primaryStagePageLayoutGenerator } from "store/modules/stage/state"

// import { control_drawer_button_children, app_control_drawer_button_children } from "materials/button/menus/index"

import { control_drawer_icon_children } from "materials/icon/menus/index"
import { smartMathMax } from "@/utils"
import { v1 } from "uuid"
class Drawer {
  constructor(vue) {
    this.context = vue
    this.request_prefix = this.context.request_prefix
  }
  init() {
    let vdrPath = this.context.$el
      .closest(".vdr")
      .classList.values()
      .find(item => item.indexOf("container_id") > -1)    
    // 先判断当前页面是否已经存在该button对应的抽屉
    const drawer = this.context.$store.state[this.request_prefix].page.pageLayoutList.find(
      pageLayout => pageLayout.options.source_id === vdrPath
    )
    if (this.context.options.drawerPath && drawer) {
      return
    }
    if (!drawer) {
      // 需要添加一个按钮组件，控制Drawer的显示
      const allRects = this.context.getAttrById.call(this.context, this.context.$store.state[this.request_prefix], {
        container_id: 0
      }).children
      let _rect_id = -1
      if (allRects.length > 0) {
        _rect_id = smartMathMax(
          ...allRects.map(function (o) {
            return o.rect_id
          })
        )
      }
      let rect_id = _rect_id + 1
      const rectAttr = JSON.parse(JSON.stringify(control_drawer_icon_children[0].attribute))
      rectAttr.options.drawerSourceId = vdrPath
      rectAttr.options.zIndex = 100000
      const isSubHeadPage = this.context?.$store?.state?.[this.context.request_prefix]?.page?.isSubHeadPage
      if (isSubHeadPage) {
        rect_id = v1()
      }
      if (isSubHeadPage) {
        rectAttr.options.inSubHead = true
        rectAttr.rect_id = rect_id
      }
      const params = {
        containerID: 0,
        data: rectAttr
      }
      this.context.$store.dispatch(this.request_prefix + "/addElement", params)
       // 不存在则创建
      let drawerParams = [new primaryStagePageLayoutGenerator(1)][0]
      // 找到当前通栏中的最大id
      const id =
        Math.max.apply(
          0,
          this.context.$store.state[this.request_prefix].page.pageLayoutList.map(pageLayout => pageLayout.id)
        ) + 1
      drawerParams.id = id
      // 设置抽屉的样式
      drawerParams.options.padding = [0, 0, 0, 0]
      drawerParams.layout.rows[0].options.height = window.innerHeight - 56 // 顶部高度50+边框6
      drawerParams.options.source_id = vdrPath
      drawerParams.options.inDocument = "drawer"
      drawerParams.options.bg = [
        {
        color: "rgba(255, 255, 255, 1)",
        isThemeColor: false,
        label: "颜色",
        type: "color"
        }
      ]
      // 抽屉默认属性
      drawerParams.options.drawerParams = {
        // 显示关闭按钮
        showClose: true,
        // 点击遮罩是否关闭抽屉
        maskClosable: true,
        direction: "ltr", // 抽屉方向 ltr:从左到右 rtl:从右到左 ttb:从上到下 btt:从下到上
        width: 300,
        title: "我是标题",
        opacity: 100,
        borderTypeFlag: 1,
        borderRadius: [0, 0, 0, 0],
        borderWidth: 2,
        borderStyle: "solid",
        borderColor: "rgb(61, 130, 242)",
        borderIsThemeColor: false,
        modalTextIsThemeColor: false,
        modalColorArr: {
          data: {
            stops: [["rgba(0, 0, 0, 0.5)", 1]],
            angle: 0
          },
          type: "color",
          label: "颜色",
          isThemeColor: false,
        },
        modalActiveNameColor: "first"
      }
      const index = this.context.$store.state[this.request_prefix].page.pageLayoutList.length - 1
      drawerParams.layout.rows[0].rectIds.push(rect_id) // 添加该按钮
      this.context.$store.dispatch(this.request_prefix + "/insertPageLayout", {
        pagelayout_data: drawerParams,
        index: index
      })
      this.context.$changeOptionsEV(vdrPath, "drawerPath", false, null, this.context.myid, true)
    } else {
      // 弹出框已经存在了，历史数据，直接绑定关系
      this.context.$changeOptionsEV(vdrPath, "drawerPath", false, null, this.context.myid, true)
    }
  }
}

export default {
  methods: {
    drawerPlugin() {
      const drawer = new Drawer(this)
      drawer.init()
    }
  }
}
